module.exports = __webpack_public_path__ + "static/media/star_filled.142f6187.svg";